import { MonthPickerInput } from '@mantine/dates';
import 'dayjs/locale/sr';
import 'dayjs/locale/de';

import i18n from 'config/localization/i18n';

const CustomMonthPicker = (props: any) => {
  const languageFromI18n = i18n.language.toLowerCase().split('-')[0] as 'EN' | 'DE' | 'SR' | 'AL' | 'ES' | 'FR' | 'IT' | 'PT' | 'TR';

  return (
    <MonthPickerInput
      withAsterisk={props.required}
      clearable={true}
      locale={languageFromI18n}
      {...props}
    />
  )
};

export default CustomMonthPicker;